'use client';

import type { InteractionType } from '~/model/InteractionType';
import { useTranslations } from 'next-intl';
import { ProjectFollowProvider } from '@/app/[locale]/(entity)/components/provider/ProjectFollowProvider';
import { useAuthenticatedContext } from '@/app/components/Provider';
import { isMainUser } from '@/app/utils/entities/user';
import { BeardmanTalking } from '~/components/Beardman/BeardmanTalking/BeardmanTalking';
import appConst from '~/const/appConst';
import { FollowedUpProjectBanner } from '../Thread/FollowedUpProjectBanner';

export const ConclusionDefault = ({ interaction }: { interaction: InteractionType }) => {
  const t = useTranslations();

  const { user } = useAuthenticatedContext();
  const isSelection = interaction['@type'] === appConst.entityTypes.selection;

  return (
    <div
      data-cy="default-conclusion"
      data-testid="default-conclusion"
    >
      <BeardmanTalking
        title={t(`${isSelection ? 'SELECTION' : 'SURVEY'}.DEFAULT_CONCLUSION`)}
        description={(
          <>
            {isSelection && (
              <>
                <p data-cy="selectionConclusion">
                  {t('SELECTION.BEARDMAN_DESCRIPTION')}
                </p>
                <p>{t.rich('SELECTION.BEARDMAN_NOTABENE')}</p>
              </>
            )}
            {interaction && isMainUser(user) && (
              <ProjectFollowProvider project={interaction.project}>
                <FollowedUpProjectBanner inverse bottom />
              </ProjectFollowProvider>
            )}
          </>
        )}
      />
    </div>
  );
};
